import { Component, OnInit } from '@angular/core';
import {InvoiceTemplateBase} from '../invoce-template-base';
import {SaleOrderInvoiceType} from "../../../../../shared/enums/sale-order-invoice-type.enum";

@Component({
  selector: 'eci-vat-monthly-form',
  templateUrl: './vat-monthly-form.component.html',
  styleUrls: ['./vat-monthly-form.component.scss']
})
export class VatMonthlyFormComponent extends InvoiceTemplateBase implements OnInit {
  public types = SaleOrderInvoiceType;

  ngOnInit(): void {
      this.model = {
          ...this.template,
          ...this.invoice,
          customerCompany: {
              ...this.template.customerCompany,
              ...this.invoice.customerCompany
          }
      };
  }



}
